import { useDispatch, useSelector } from "react-redux";
import {
  actionUpdateCapitalization,
  resetUpdateCapitalization,
} from "../../routes/app/auth/employer/store";
import React, { useEffect, useState } from "react";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../common/app_constant";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import ErrorLabel from "../error_label";
import { useForm } from "react-hook-form";
import $ from "jquery";

const AddCapitalization = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const { UpdateCapitalization } = useSelector((state) => ({
    ...state.employerStore,
  }));

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (UpdateCapitalization && props.isCapitalizationModel) {
      dispatch(resetUpdateCapitalization());
      $("#add_edit_capitalization").prop("disabled", false);
      if (UpdateCapitalization.status) {
        setLoading(false)
        // toast.success(UpdateCapitalization.message, {
        //   duration: TOAST_DURATION,
        //   position: TOAST_POSITION,
        //   style: {
        //     color: TOAST_SUCCESS_COLOR,
        //   },
        // });
        $("#app-body").removeClass("modal-open");
        $(".modal-backdrop").remove();
        setValue("recovery_date", null);
        props.handleCapClose()
        window.location.reload()
      } else {
        setLoading(false)
        props.handleCapClose();
        switch (UpdateCapitalization.status_code) {
        }
      }
    }
  }, [UpdateCapitalization]);

  useEffect(() => {
    if (props.isCapitalizationModel) {
      $('#app-body').addClass('modal-open')
      $("#app-body").append('<div class="modal-backdrop fade show"></div>');
    } else {
      $('#app-body').removeClass('modal-open')
      $('.modal-backdrop').remove()
    }
  }, [props.isCapitalizationModel]);

  const onSubmit = (data) => {
    data.policy_id = props?.selectedIds;
    data.price_of_vehicle_without_insurance_and_tcs = Number(data.price_of_vehicle_without_insurance_and_tcs) || 0;

    $("#add-edit-capitalization-loader").removeClass("hidden");
    $("#add_edit_capitalization").prop("disabled", true);
    dispatch(actionUpdateCapitalization(data));
    setLoading(true)
  };
  return (
    <>
      <div
        class="modal "
        id="capitalization"
        tabindex={-1}
        data-bs-backdrop="static"
        aria-labelledby="capitalization"
        aria-hidden="true"
        style={{ display: props.isCapitalizationModel ? "block" : "none" }}
      >
        <div class="modal-dialog modal-dialog-sm">
          <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="capitalization">
                  Update Capitalization Date
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    props.handleCapClose()
                    $("#app-body").removeClass("modal-open");
                    $(".modal-backdrop").remove();
                    setValue("recovery_date", null);
                  }}
                ></button>
              </div>
              <div class="modal-body">
                <div className="col-12 mb-2">
                  <label>Capitalization Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="capitalization_date"
                    {...register("capitalization_date", {
                      required: "This is required",
                    })}
                  />
                  {errors.capitalization_date && (
                    <ErrorLabel message={errors?.capitalization_date.message} />
                  )}
                </div>
                {
                  props?.selectedIds?.length === 1 &&

                  <div className="col-12">
                    <label>
                      {/* Price Of Vehicle Without ( Insurance & TCS ) */}
                      Price of Vehicle ( Without Insurance & TCS )
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      // onFocus={numberWheelChange}
                      id="price_of_vehicle_without_insurance_and_tcs "
                      name="price_of_vehicle_without_insurance_and_tcs "
                      {...register("price_of_vehicle_without_insurance_and_tcs", {
                        onChange: (e) => {
                          setValue("price_of_vehicle_without_insurance_and_tcs", Number(e.target.value) || 0);
                        }
                      })}
                    />
                    {errors.price_of_vehicle_without_insurance_and_tcs && (
                      <ErrorLabel message={errors.price_of_vehicle_without_insurance_and_tcs?.message} />
                    )}
                  </div>
                }
              </div>
              <div class="modal-footer text-center">
                {
                  loading ?
                    <button
                      id="add_edit_capitalization"
                      className="btn btn-primary shadow round me-2"
                      type="submit"
                    >
                      <div className="d-flex align-items-center">
                        Apply
                        <span
                          id="add-edit-capitalization-loader"
                          className="spinner-border spinner-border-sm ml-half hidden"
                        ></span>
                      </div>
                    </button>
                    :
                    <button
                      id="add_edit_capitalization"
                      className="btn btn-primary shadow round me-2"
                      type="submit"
                    >
                      <div className="d-flex align-items-center">
                        Apply
                      </div>
                    </button>
                }
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCapitalization;
